<template>

</template>
<script>
    export default {
        props: {
            id: String,
            name: String,
            api: String,
            options: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        }
    }
</script>
